import { FC } from 'react';

import { IcAddUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView } from '@gem/ui-kit';

import { useCallAddSpeakerLinkPresenter } from './CallAddSpeakerLink.presenter';
import styles from './CallAddSpeakerLink.styles.m.css';
import { ICallAddSpeakerLinkProps } from './CallAddSpeakerLink.types';

export const CallAddSpeakerLink: FC<ICallAddSpeakerLinkProps> = (props) => {
  const presenter = useCallAddSpeakerLinkPresenter(props);
  const { t } = useTranslation();

  return (
    <button
      className={styles.link}
      onClick={presenter.onClick}
    >
      <IconView
        Icon={IcAddUserIcon}
        className={styles.icon}
      />
      <span className={styles.text}>{t('webinar_add_speaker_button')}</span>
    </button>
  );
};
